import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import config from "../config";
import Routes from "./components/routes";
import theme from "./components/theme";
import NavigationScroll from "./components/theme/layout/NavigationScroll";
import { AuthHandler } from "./hooks/authHandler";
import { AuthProvider, useAuth } from "./hooks/useAuth";

function App() {
  const customization = useSelector((state) => (state as any).customization);
  return (
    <BrowserRouter basename={config.basename}>
      <AuthProvider>
        <AuthConsumer />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme(customization)}>
              <CssBaseline />
              <NavigationScroll>
                <Routes />
              </NavigationScroll>
            </ThemeProvider>
          </StyledEngineProvider>
        </LocalizationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

function AuthConsumer() {
  const { logout }: any = useAuth() || {};

  useEffect(() => {
    AuthHandler.setLogoutCallback(logout);
  }, [logout]);

  // Token refresh is handled entirely by useAuth's checkAndRefreshToken.
  // Do NOT add a second refresh timer here — it causes timer leaks and race conditions.

  return null;
}

export default App;
